import { render, staticRenderFns } from "./beauty.vue?vue&type=template&id=7405cd27&scoped=true"
import script from "./beauty.vue?vue&type=script&lang=js"
export * from "./beauty.vue?vue&type=script&lang=js"
import style0 from "./beauty.vue?vue&type=style&index=0&id=7405cd27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7405cd27",
  null
  
)

export default component.exports